import { DECORATIVE_IMAGE_ALT } from "../constants";
import editorLoadingAnimation from "../assets/editor/loading-animation.gif";

type GlobalLoadingPageProps = {
  text: string;
};

const GlobalLoadingPage = (props: GlobalLoadingPageProps) => (
  <main class="flex h-screen flex-col items-center justify-center gap-4 bg-surface-default">
    <img class="size-10" src={editorLoadingAnimation} alt={DECORATIVE_IMAGE_ALT} />
    <h1 class="text-medium-regular text-secondary">{props.text}</h1>
  </main>
);

export default GlobalLoadingPage;
